module.exports = __webpack_public_path__ + "static/media/vlive.51be536b.jpg";